/*
 * Error store: This file stores the dependencies of errors in the application.
 * It is a error store which indicates type, component and message of errors.
 */

import { types,ModelInstanceTypeProps,ModelProperties } from 'mobx-state-tree';
import { IErrorObject } from '../../common/components/error-manager/IErrorManagerInterface';
import { CQAppConstant } from '../../app-constants';


/** 
 * @description Error Model Initialization
 */
export const CQErrorManagerModel = types.model({
    errorType: types.enumeration<string>(CQAppConstant.CQ_ERROR_TYPES_TEXT, CQAppConstant.CQ_ERROR_TYPES),
    errorMessage: types.string,
    errorMessages:  types.optional(types.array(types.string),[]),
    componentName: types.string,
    errorFlag: types.boolean,
    redirectTo : types.optional(types.string,'')
})
    .actions((self: ModelInstanceTypeProps<ModelProperties>) => ({
        dispatchError(error: IErrorObject) {
            if(error.errorStatus === CQAppConstant.API_RESPONSE_CODES.FORBIDDEN_REQUEST){
                self.errorType = CQAppConstant.ERROR_SESSION;
                self.errorMessage = CQAppConstant.ERROR_MESSAGES.SESSION_EXPIRED;
                self.componentName = error.componentName;
                self.errorFlag = true;
            }else if(typeof error.errorStatus !== 'undefined'){
                const errorMessage = error.errorMessage;
                self.errorType = error.errorType;
                self.errorMessage = errorMessage;
                self.componentName = error.componentName;
                self.errorFlag = true;
            }else if(error.errorType === CQAppConstant.UNKNOWN_PUBLISH_ERROR){
                self.errorType = error.errorType;
                self.errorMessage = error.errorMessage;
                self.errorMessages = error.errorMessages;
                self.componentName = error.componentName;
                self.errorFlag = true;
            }else if(error.errorType === CQAppConstant.BASE_CLASS_ALREADY_EXIST_WARNING || error.errorType === CQAppConstant.COMPONENT_NAME_ALREADY_EXIST_WARNING){
                self.errorType = error.errorType;
                self.errorMessage = error.errorMessage;
                self.errorMessages = error.errorMessages;
                self.componentName = error.componentName;
                self.errorFlag = true;
            }else{
                const errorMessage = (error.errorType === CQAppConstant.DEPLOY_FAILED || error.errorType === CQAppConstant.SAME_BASE_CLASS_ERROR) ? error.errorMessage : CQAppConstant.ERROR_MESSAGES.UNKNOWN_ERROR;
                self.errorType = error.errorType;
                self.errorMessage = errorMessage;
                self.errorMessages = error.errorMessages;
                self.componentName = error.componentName;
                self.errorFlag = true;
            }
        },
        hide() {
            self.errorFlag = false;
        }
    }));
    
